import { useEffect } from "react";
import loadAffirmPayments from "helpers/load-affirm";

const AffirmPayments = ({ price }) => {
    useEffect(() => {
        const affirmConfig = {
            public_api_key: "OMF2VGA6UR2MBWXN",
            script: "https://cdn1.affirm.com/js/v2/affirm.js",
        };
        loadAffirmPayments(window, affirmConfig, "affirm", "checkout", "ui", "script", "ready", "jsReady");
    }, [price]);
};

export default AffirmPayments;
